import type { ServiceOrderStatus } from '../serviceOrders/serviceOrder.types';
import { ServiceCategory, ServiceType } from './commonServiceOrder.types';
import type { ServiceOptionStatus } from '../serviceOptions/serviceOption.types';
import type { GetServiceOrdersFilterQueryParams } from '../../api/serviceOrdersApi';
import { ServiceOrderSearchMode } from '../../reducers/serviceOrdersSlice';
import { parseUniqueEntries } from '../../sharedComponents/inputListParser';

export type ServiceOrderModalFilters = {
    startDateFilter: Date | undefined;
    endDateFilter: Date | undefined;
    serviceTypeFilter: ServiceType[];
    locationFilter: string | undefined;
};

export type ServiceOrderFilters = {
    statusFilterForOrders: ServiceOrderStatus[];
    statusFilterForOptions: ServiceOptionStatus[];
    modalFilters: ServiceOrderModalFilters;
};

export const mapServiceOrderFiltersToQueryParams = (
    modalFilters: ServiceOrderModalFilters,
    statuses: ServiceOrderStatus[],
    category: ServiceCategory,
): GetServiceOrdersFilterQueryParams => ({
    location: modalFilters.locationFilter,
    statuses,
    serviceTypes: modalFilters.serviceTypeFilter,
    orderIssuedAtAfter: modalFilters.startDateFilter,
    orderIssuedAtBefore: modalFilters.endDateFilter,
    archived: category === ServiceCategory.ARCHIVE,
});

export const mapServiceOrderSearchToQueryParams = (
    searchMode: ServiceOrderSearchMode,
    searchValue: string,
): GetServiceOrdersFilterQueryParams => {
    const trimmedValue = searchValue.trim();

    if (trimmedValue.length === 0) {
        return {};
    }

    switch (searchMode) {
        case ServiceOrderSearchMode.VIN: {
            const vins = parseUniqueEntries(trimmedValue);
            return vins.length > 0 ? { vins } : {};
        }
        case ServiceOrderSearchMode.EXTERNAL_ORDER_ID:
            return { externalOrderId: trimmedValue };
        case ServiceOrderSearchMode.EXTERNAL_OPTION_ID:
            return { externalOptionId: trimmedValue };
    }
};
